import { flipObject } from "./flipObject";

export const facetCategoryMap = {
  gender: "gender",
  categories: "categories",
  collection: "collection",
  materials: "materials",
  "colors.BaseColor": "colours",
  review_value_rounded: "rating",
};

// flips the key and values in facetCategoryMap
export const reverseFacetCategoryMap = flipObject(facetCategoryMap);